<template>
    <div class="con">
        <div class="banner">
            <img class="bg" src="../assets/news/ban.png" alt="">
            <img class="s" src="../assets/news/c.png" alt="">
        </div>
        <div class="main">
            <div class="nav">
                <div v-for="(item,index) in $t('news').list" :key="index" :class="{'showLine':select===index}" @click="goto(index)">
                    <span>{{item}}</span>
                    <span></span>
                </div>
            </div>
            <transition name="fade">
                <div class="pp"  v-if="select===0">
                    <p class="title">{{$t('news').list[0]}}</p>
                    <swiper class="swiper" :options="swiperOption" >
                        <swiper-slide class="item"  v-for="(item,index) in newsList" :key="index" >
                            <div class="left" @click="gotoInfo(item.ID)">
                                <img :src="`https://www.wellish.cn/upload/${item.SMALLPIC}`" alt="">
                            </div>
                            <div class="right" @click="gotoInfo(item.ID)">
                                <p>{{item.SHOWTIME}}</p>
                                <p>{{item.TITLE}}</p>
                                <p>{{item.ZY}}</p>
                                <p>|　<span>{{$t('btn1')}}</span></p>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-pagination">

                    </div>
                    <div class="newsList">
                         <div class="oneItem" v-for="(item,index) in newsList2" :key="index" @click="gotoInfo(item.ID)">
                             <p>{{item.SHOWTIME}}</p>
                             <p>{{item.TITLE}}</p>
                             <p>{{item.ZY}}</p>
                         </div>
                    </div>
                    <div class="more">
                          <span @click="showMore">
          <a>
              <div>
                             <i class="iconfont icon-shuaxin"></i>
              </div>

              <p>{{$t('btn2')}}</p>
          </a>
          </span>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="hy" v-if="select===1">
                    <p class="title">{{$t('news').list[1]}}</p>
                    <swiper class="swiper" :options="swiperOption1" >
                        <swiper-slide class="item"  v-for="(item,index) in hyList" :key="index" >
                            <div class="left" @click="gotoInfo(item.ID)">
                                <img :src="`https://www.wellish.cn/upload/${item.SMALLPIC}`" alt="">
                                <!--                                <img :src="`http://aomate.sansg.com/upload/${item.BIGIMG}`" alt="">-->
                            </div>
                            <div class="right" @click="gotoInfo(item.ID)">
                                <p>{{item.SHOWTIME}}</p>
                                <p>{{item.TITLE}}</p>
                                <p>{{item.ZY}}</p>
                                <p>|　<span>{{$t('btn1')}}</span></p>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-pagination">

                    </div>
                    <div class="newsList">
                        <div class="oneItem" v-for="(item,index) in hyList2" :key="index" @click="gotoInfo(item.ID)">
                            <p>{{item.SHOWTIME}}</p>
                            <p>{{item.TITLE}}</p>
                            <p>{{item.ZY}}</p>
                        </div>
                    </div>
                    <div class="more">
                          <span @click="showMore1">
          <a>
              <div>
                        <i class="iconfont icon-shuaxin"></i>
              </div>

              <p>{{$t('btn2')}}</p>
          </a>
          </span>
                    </div>
                </div>
            </transition>
            <transition name="fade">
                <div class="zl" v-if="select===2">
                    <p class="title">{{$t('news').list[2]}}</p>
                    <div class="mainCon">
                        <div class="item" v-for="(item,index) in downList" :key="index"  >
                            <span class="a">{{item.TITLE}}</span>
                            <span class="c">
            <a :href="`https://www.wellish.cn/upload/${item.FILE}`"  target="_blank" > <i class="iconfont icon-xiazai"></i></a>
       </span>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import  footComponent from '../components/foot'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getNewsUrl} from '../util/lang'
    export default {
        name: "faq",
        data(){
            return{
                select:0,
                id:'',
                id1:'',
                page:'',
                page1:'',
                totalPage:'',
                totalPage1:'',
                swiperOption:{
                    speed:2000,
                    pagination: {
                        el: ".pp .swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + '"><i></i></span>';
                        }
                    },
                },
                swiperOption1:{
                    speed:2000,
                    pagination: {
                        el: ".hy .swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + '"><i></i></span>';
                        }
                    },
                },
                list:[
                    '品牌动态',
                    '行业资讯',
                    '资料下载'
                ],
                newsList:[],
                newsList2:[],
                hyList:[],
                hyList2:[],
                downList:[]
            }
        },
        components:{footComponent,swiper, swiperSlide},
        mounted(){
            this.$nextTick(()=>{
                if(this.$i18n.locale==='en'){
                    this.getPp('34')
                    this.getDown('33')
                    this.getHy('35')
                }else{
                    this.getPp('28')
                    this.getDown('27')
                    this.getHy('29')
                }
            })
        },
        methods:{
            getDown(id){
                const url = `${getNewsUrl(this.$i18n.locale,id,1000,1)}`
                this.$axios.get(url).then(res => {
                    this.downList=res.data.newsArr
                })
            },
            getPp(id){
                this.page=2
                this.id=id
                const url = `${getNewsUrl(this.$i18n.locale,id,4,1)}`
                const url1 = `${getNewsUrl(this.$i18n.locale,id,1000,1)}`
                this.$axios.get(url).then(res => {
                    res.data.newsArr.map((item)=>{
                        item.SHOWTIME=item.SHOWTIME.slice(0,11)
                    })
                    this.newsList2=res.data.newsArr
                    this.totalPage=res.data.pagerShow.totalPagers
                })

                this.$axios.get(url1).then(res => {
                    res.data.newsArr.map((item)=>{
                        item.SHOWTIME=item.SHOWTIME.slice(0,11)
                        if(item.ISCOMMEND==='1')
                            this.newsList.push(item)
                    })
                })

            },
            getHy(id){
                this.page1=2
                this.id1=id
                const url = `${getNewsUrl(this.$i18n.locale,id,4,1)}`
                const url1 = `${getNewsUrl(this.$i18n.locale,id,1000,1)}`
                this.$axios.get(url).then(res => {
                    res.data.newsArr.map((item)=>{
                        item.SHOWTIME=item.SHOWTIME.slice(0,11)
                    })
                    this.hyList2=res.data.newsArr
                    this.totalPage1=res.data.pagerShow.totalPagers
                })

                this.$axios.get(url1).then(res => {
                    res.data.newsArr.map((item)=>{
                        item.SHOWTIME=item.SHOWTIME.slice(0,11)
                        if(item.ISCOMMEND==='1')
                            this.hyList.push(item)
                    })
                })

            },
            showMore(){
                if(this.page<=this.totalPage){
                    this.$nextTick(()=>{
                        const url = `${getNewsUrl(this.$i18n.locale,this.id,4,this.page++)}`
                        this.$axios.get(url).then(res => {
                            res.data.newsArr.map((item)=>{
                                item.SHOWTIME=item.SHOWTIME.slice(0,11)
                            })
                                this.newsList2= this.newsList2.concat(res.data.newsArr)
                        })

                    })
                }else{
                    this.$notify({
                        title: 'Prompt',
                        message: 'Already Loaded',
                        offset: 100
                    });
                }
            },
            showMore1(){
                if(this.page1<=this.totalPage1){
                    this.$nextTick(()=>{
                        const url = `${getNewsUrl(this.$i18n.locale,this.id1,4,this.page1++)}`
                        this.$axios.get(url).then(res => {
                            res.data.newsArr.map((item)=>{
                                item.SHOWTIME=item.SHOWTIME.slice(0,11)
                            })
                            this.hyList2= this.hyList2.concat(res.data.newsArr)
                        })

                    })
                }else{
                    this.$notify({
                        title: 'Prompt',
                        message: 'Already Loaded',
                        offset: 100
                    });
                }
            },
            goto(index){
                this.select=index
            },
            gotoInfo(id){
                const  link=`/newsInfo.html?nid=${id}`
                window.open(link) // this.project.link
            },
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    animation: all 1s linear forwards;
    @keyframes all {
        from{
            transform: translateY(60px);
        }
        to{
            transform: translateY(0);
        }
    }
    .banner{
        width:100%;
        position: relative;
        .bg{
            width:100%;
            object-fit: cover;
            display: block;
        }
        .s{
            position: absolute;
            left:20%;
            bottom:20%;
        }
    }
    .main{
        width:100%;
        background: linear-gradient(to bottom,white,#F0F1F6);
        .nav{
            width:1280px;
            margin: 0 auto;
            justify-content: center;
            display: flex;
            flex-direction: row;
            div{
                padding: 10px 20px;
                font-family: "Fira Code Medium";
                font-weight: lighter;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                span:nth-child(1){
                    transition: all 2s;
                }
                span:nth-child(2){
                    display: inline-block;
                    height:6px;
                    width:6px;
                    transform: rotate(45deg);
                    background-color: #0061AE;
                    margin-top: 5px;
                    transition: all 2s;
                    opacity: 0;
                }
            }
            div::before{
                content:'';
                display: inline-block;
                width:30%;
                height:1px;
                background: linear-gradient(to right,white, #0061AE);
                position: absolute;
                left:12%;
                top:70%;
                transition: all 2s;
                opacity: 0;
            }
            div::after{
                content:'';
                display: inline-block;
                width:30%;
                height:1px;
                background: linear-gradient(to right,white, #0061AE);
                position: absolute;
                right:14%;
                top:70%;
                opacity: 0;
                transition: all 2s;
            }
            div:hover{
                span:nth-child(1){
                    color:#0061AE;
                }
                span:nth-child(2){
                    opacity: 1;
                }
            }
            div:hover::before{
                opacity: 1;
            }
            div:hover::after{
                opacity: 1;
            }
            .showLine::before{
                opacity: 1;
            }
            .showLine::after{
                opacity: 1;
            }
            .showLine{
                span:nth-child(1){
                    color:#0061AE;
                }
                span:nth-child(2){
                    opacity: 1;
                }
            }
        }
        .pp,.hy,.zl{
            width:100%;
            padding-bottom: 60px;
            .title{
                width:1280px;
                margin: 80px auto;
                font-size: 40px;
                font-family: "Fira Code Medium";
                font-weight: lighter;
                position: relative;
                padding-bottom: 10px;
            }
            .title::before{
                content:'';
                display: inline-block;
                position: absolute;
                left:0;
                bottom:0;
                background-color: #0061AE;
                height:1px;
                width:60px;
            }
        }
        .pp,.hy{
            position: relative;
            .swiper{
                width:1280px;
                margin: 0 auto;
                .item{
                    display: flex;
                    flex-direction: row;
                    cursor: pointer;
                    .left{
                        width:606px;
                        height:352px;
                        overflow: hidden;
                        img{
                            display: block;
                            transition: all 600ms;
                        }
                    }
                    .right{
                        background-color: #0061AE;
                        width:55%;
                        p{
                            color:white;
                            font-family: "Fira Code Medium";
                            font-weight: lighter;
                            width:80%;
                            margin-left: 10%;
                            margin-top: 40px;
                            line-height: 30px;
                            font-size: 14px;
                        }
                        p:nth-child(1){
                            font-size: 16px;
                        }
                        p:nth-child(2){
                            font-size: 18px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            overflow: hidden;
                            height:30px;
                        }
                        p:nth-child(3){
                            color:#A3D6FF;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            height:60px;
                        }
                        p:nth-child(4){
                            display: flex;
                            flex-direction: row;
                            span{
                                display: block;
                                transition: all 600ms;
                            }
                        }
                    }
                }
                .item:hover{
                    .left{
                        img{
                            transform: scale(1.05);
                        }
                    }
                    .right{
                        p:nth-child(4){
                            span{
                                transform: translateX(10px);
                            }
                        }

                    }
                }
            }
            .newsList{
                width:1280px;
                margin: 0 auto;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin-top: 40px;
                .oneItem{
                    width:45%;
                    margin-top: 10px;
                    padding: 30px 0;
                   font-family: "Fira Code Medium";
                    font-weight: lighter;
                    cursor: pointer;
                    border-bottom: 1px solid #D8D8D8;
                    position: relative;
                    p:nth-child(1){
                        color:#0061AE;
                        padding-bottom: 30px;
                    }
                    p:nth-child(2){
                        font-size: 18px;
                        color:#343434;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        height:25px;
                    }
                    p:nth-child(3){
                        color:#1D1D1D;
                        font-size: 14px;
                        line-height: 30px;
                        height:60px;
                        display: -webkit-box;
                        margin-top: 30px;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                }
                .oneItem::before{
                    position: absolute;
                    left:0;
                    bottom:-1px;
                    content:'';
                    display: block;
                    width:0;
                    height:1px;
                    background-color: #0061AE;
                    transition: all 2s;
                }
                .oneItem:nth-child(even){
                    margin-left: 10%;
                }
                .oneItem:hover::before{
                    width:100%;
                }
            }
            .more{
                       width:100%;
                       text-align: center;
                       margin-top: 60px;
                       span{
                           text-align: center;
                           width:180px;
                           display: inline-block;
                           height:30px;
                           line-height: 30px;
                           font-family: "Fira Code Medium";
                           font-weight: lighter;
                           font-size: 12px;
                           cursor: pointer;
                           position: relative;
                           background-color:#F0EFEF;
                           -webkit-transition: all 2s;
                           transition: all 2s;
                           a{
                               position: absolute;
                               width:100%;
                               left:0;
                               display: flex;
                               flex-direction: row;
                               justify-content: center;
                               div{
                                   transition: all 2s;
                                   position: absolute;
                                   left:20%;
                                   top:2%;
                                   height:95%;
                                   i{
                                       font-size: 20px;
                                       transform-origin: center bottom;
                                   }
                               }
                               p{
                                   transition: all 2s;
                                   padding-left: 10px;
                               }
                           }
                       }
                       span:hover{
                           background-color: #00589E;
                           div{
                               transform: rotate(360deg);
                           }
                       }
                       span::before{
                           content: "";
                           display: block;
                           height: 36px;
                           left: -3px;
                           position: absolute;
                           top: -3px;
                           width: 10px;
                           border-left: 1px solid #2D2926;
                           border-top: 1px solid #2D2926;
                           border-bottom: 1px solid #2D2926;
                           transition: .5s;
                       }
                       span::after{
                           content: "";
                           display: block;
                           height: 36px;
                           right: -3px;
                           position: absolute;
                           top: -3px;
                           width: 10px;
                           border-right: 1px solid #2D2926;
                           border-top: 1px solid #2D2926;
                           border-bottom: 1px solid #2D2926;
                           transition: .5s;
                       }
                       span:hover::before{
                           top:-1px;
                           left:-1px;
                           height:100%;
                           width:90px;
                       }
                       span:hover{
                           background-color: #00589E;
                           a{
                               p,i{
                                   color:white;
                               }
                           }
                       }
                       span:hover::after{
                           top:-1px;
                           right:-1px;
                           height:100%;
                           width:90px;
                       }
                   }
        }
        .zl{
            .mainCon{
                width:1280px;
                display: flex;
                flex-direction: column;
                margin: 60px auto;
                .item{
                    width:98%;
                    border-top: 1px solid #E5E5E5;
                    border-bottom: 1px solid #E5E5E5;
                    display: flex;
                    flex-direction: row;
                    cursor: pointer;
                    justify-content: center;
                    -webkit-transition: all .5s;
                    transition: all .5s;
                    line-height: 60px;
                    padding-left: 2%;
                font-family: "Fira Code Medium";
                    font-weight: lighter;
                    i{
                        font-size: 20px;
                    }
                    .c{
                        padding-left: 5%;
                        a{
                            text-decoration: none;
                            transition: all 2s;
                        }
                    }
                }
                .item:hover{
                    color:#0061AE;
                }
                .item:hover .c a{
                    color:#0061AE;
                }
            }
        }
    }
    @media screen and (max-width:450px) {
        .banner {
            .bg {
                height: 400px;
            }

            .s {
                left: 5%;
                height: 100px;
                width: 90%;
                object-fit: contain;
            }
        }
            .main {
                .nav {
                    width: 95%;
                    flex-wrap: wrap;

                    div {
                        width: 50%;
                    }
                }
                .pp,.hy{
                    .title {
                        width: 90%;
                        margin: 40px auto;
                        font-size: 32px;
                    }
                    .swiper{
                        width:95%;
                        .item{
                            width:100%;
                            flex-direction: column;
                            .left{
                                height:200px;
                                width:100%;
                                img{
                                    height:100%;
                                    width:100%;
                                    object-fit: cover;
                                }
                            }
                            .right{
                                width:100%;
                                padding: 10px 0;
                                height:280px;
                                p{
                                    width:90%;
                                    margin-left: 5%;
                                    margin-top: 10px;
                                }
                            }
                        }
                    }
                    .newsList{
                        width:95%;
                        flex-direction: column;
                        .oneItem{
                            width:100%;
                            margin-top: 20px;
                        }
                        .oneItem:nth-child(even){
                            margin-left: 0;
                        }
                    }
                }
                .zl{
                    .title {
                        width: 90%;
                        margin: 40px auto;
                        font-size: 32px;
                    }
                    .mainCon{
                        width:95%;
                        .item{
                            width:100%;
                            .a{
                                font-size: 14px;
                                width:80%;
                                height:60px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                            }
                        }
                    }
                }
        }
    }
}
</style>
<style scoped>
    .pp .swiper-pagination {
        top:450px;
        left:50%;
        width: 20%;
    }
    .pp .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 10px;
        height:10px;
        border-radius: 20px;
        margin: 0 5px;
        background-color: white;
    }
    .pp .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }


    .hy .swiper-pagination {
        top:450px;
        left:50%;
        width: 20%;
    }
    .hy .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 10px;
        height:10px;
        border-radius: 20px;
        margin: 0 5px;
        background-color: white;
    }
    .hy .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    @media screen and (max-width:450px){
        .pp .swiper-pagination{
            left:36%;
            top:560px;
        }
    }
</style>